import { DEFAULT_EXPORT } from '../constants'

export const EXPORT_STATUS = {
  IDLE: 'idle',
  QUEUED: 'queued',
  PREPARING: 'preparing',
  ERROR: 'error',
}

export const EXPORT_IN_FLIGHT_STATUSES = new Set([EXPORT_STATUS.QUEUED, EXPORT_STATUS.PREPARING])

const idsMatch = (left, right) => left != null && right != null && String(left) === String(right)
const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key)

export const isExportOwnedByCurrentView = (state) => {
  const activeConversion = state.export?.activeConversion
  if (!activeConversion) return false

  const openedModelId = state.ui?.openedModel?.id
  const currentAssetId = state.viewer?.inputThreeD
  // Honor an explicit ownerModelId (even when null, which forces the source-asset
  // fallback below); only conversions created without the key fall back to runId.
  const ownerModelId = hasOwn(activeConversion, 'ownerModelId')
    ? activeConversion.ownerModelId
    : activeConversion.runId

  if (ownerModelId != null) {
    return idsMatch(ownerModelId, openedModelId)
  }

  return idsMatch(activeConversion.sourceAssetId, currentAssetId)
}

export const isExportInFlightForCurrentView = state =>
  EXPORT_IN_FLIGHT_STATUSES.has(state.export?.status) && isExportOwnedByCurrentView(state)

export const initialExportState = {
  export: { ...DEFAULT_EXPORT },
}
